import { Box, Flex } from "@chakra-ui/react";
import { useHookstate } from "@hookstate/core";
import {
  useIsSmallBreakpoint,
  useMobileBreakpoint,
} from "../../utils/useBreakpoints";
import { appStore } from "../../hookstate/appStore";
import { ButtonCarousel } from "../carousel/ButtonCarousel";
import { SelectableCard } from "../cards/SelectableCard";

export interface ArchetypeSelectionStepProps {
  selectedSlug?: string;
  onSelect: (slug: string) => void;
}

export function ArchetypeSelectionStep({
  selectedSlug,
  onSelect,
}: ArchetypeSelectionStepProps) {
  const isSmall = useIsSmallBreakpoint();
  const isMobile = useMobileBreakpoint();
  const archetypes = useHookstate(appStore.init.archetypes).get() ?? [];

  const activeSlideIndex = archetypes.findIndex(
    (archetype) => archetype.slug === selectedSlug,
  );

  const adjustedSlideIndex =
    activeSlideIndex % 2 ? activeSlideIndex : activeSlideIndex;

  return (
    <Flex justifyContent="center" width="100%" gap="16px" flexWrap="wrap">
      {isSmall ? (
        archetypes.map((archetype) => (
          <Flex
            key={archetype.id}
            p="16px"
            flex={isMobile ? "auto" : "0 1 45%"}
            justifyContent="center"
          >
            <SelectableCard
              onClick={() => onSelect(archetype.slug)}
              image={archetype.image_url}
              title={archetype.display_name}
              description={archetype.description}
              isSelected={selectedSlug === archetype.slug}
            />
          </Flex>
        ))
      ) : (
        <ButtonCarousel
          width="100%"
          containerProps={{ gap: 4, padding: "12px" }}
          slidesToScroll={1}
          align="center"
          big
          dontFadeButtons
          includeSpacer
          activeSlideIndex={adjustedSlideIndex}
        >
          <Box minWidth="24px" />
          {archetypes.map((archetype) => (
            <Box key={archetype.id} height="335px" overflow="visible">
              <SelectableCard
                onClick={() => onSelect(archetype.slug)}
                image={archetype.image_url}
                title={archetype.display_name}
                description={archetype.description}
                isSelected={selectedSlug === archetype.slug}
              />
            </Box>
          ))}
        </ButtonCarousel>
      )}
    </Flex>
  );
}
